<template>
  <BaseField
    ref="field"
    v-bind="attributes"
    v-on="$listeners"
    class="field-password"
    :class="`field-password_${type}`"
  >
    <button
      v-if="isEyeVisible"
      type="button"
      slot="container"
      class="field-password__toggle"
      @click="toggleType"
    >
      <BaseIcon
        :name="icon"
        class="field-password__eye"
      />
    </button>
  </BaseField>
</template>

<script>
import BaseField from '@/components/BaseField.vue';
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'FieldPassword',
  inheritAttrs: false,
  components: {
    BaseField,
    BaseIcon,
  },
  props: {
    minLength: {
      type: Number,
      default: 6,
    },
    maxLength: {
      type: Number,
      default: 16,
    },
    hasEyeButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isHidden: true,
    };
  },
  computed: {
    type() {
      return this.isHidden ? 'password' : 'text';
    },
    icon() {
      return this.isHidden ? 'lash' : 'eye';
    },
    isEyeVisible() {
      return Boolean(this.hasEyeButton && this.$attrs.value);
    },
    attributes() {
      return {
        type: this.type,
        label: this.$t('fields.passwordLabel'),
        placeholder: this.$t('fields.passwordPlaceholder'),
        errorMessage: this.$t('fields.passwordError', {
          min: this.minLength,
          max: this.maxLength,
        }),
        completeValidator: this.checkPassword,
        required: true,
        ...this.$attrs,
      };
    },
  },
  watch: {
    // фикс бага (ввод в поле type=password не продлевает взаимодействие)
    '$attrs.value': 'prolongInteraction',
  },
  methods: {
    toggleType() {
      this.isHidden = !this.isHidden;
    },
    focus() {
      return this.$refs.field?.focus();
    },
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    checkHasValue() {
      return this.$refs.field?.checkHasValue();
    },
    checkPassword(password) {
      return password.length >= this.minLength && password.length <= this.maxLength;
    },
    prolongInteraction() {
      if (!this.isHidden) return;
      this.$robot.interactionService.start();
    },
  },
};
</script>

<style lang="stylus">
.field-password
  &__toggle
    abs top right
    display flex
    align-items center
    justify-content center
    width 3.4em
    height @width
    padding 1.05em
    background none
    color $c_text_dim
    outline none
    border 0
    z-index 5
    ~/.field_has_clear &
      margin-right (@width - 0.7em)
    ~/_text &
      color $c_primary
    .field__container_has_tooltip &
      right 4em

  &__eye
    width 100%
    height 100%
</style>
